import React from 'react';
import { RangeSliderElement } from './styles';
import kinds from './kinds';
export default function RangeSlider({ kind = 'default', sliderHeight = 2, thumbBorderRadius = 5, thumbHeight = 10, thumbWidth = 10, type = 'range', ...rest }) {
    return (React.createElement(RangeSliderElement, Object.assign({ sliderHeight: sliderHeight, thumbBorderRadius: thumbBorderRadius, thumbHeight: thumbHeight, thumbWidth: thumbWidth, type: type }, kinds[kind], rest)));
}
